import React, { useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import { Link } from "react-router-dom";
import { socket } from "src/socket";
import Moment from 'react-moment';
import Avatar from "@mui/material/Avatar";
import PersonIcon from "@mui/icons-material/Person";

//Services
import { getUserId } from "src/Api/services/storageService";
import { getMessagePending } from 'src/Api/services/notificationService';

function MessagesPopup(props) {

    const {
        show,
        setShow,
        setPending
    } = props;


    const session = useSelector((state) => state.session);
    const userId = session?.user?.id || getUserId();
    const [loading, setLoading] = useState(true);
    const [messages, setMessages] = useState([]);

    const fetchData = async () => {
        if (!userId) return;
        let filter = {
            direction: 'asc',
            role: session.userType === 'coach' ? 'coach' : session.user.role
        }
        await getMessagePending(userId, filter)
            .then((resp) => {
                setMessages(resp.data.rooms);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                console.log("Error", err);
            })
    }

    useEffect(() => {
        fetchData();
        socket.on('NEW_MESSAGE', (body) => {
            setMessages(state => [...state, body]);
        });
        return () => {
            socket.off('NEW_MESSAGE');
        };
    }, []);

    useEffect(() => {
        if (messages.length > 0)
            setPending(true);
    }, [messages]);

    return (
        <Menu
            id="message-menu"
            anchorEl={show}
            open={Boolean(show)}
            onClose={() => {
                setShow(null);
            }}
            anchorOrigin={{
                vertical: 'center',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            PaperProps={{
                style: {
                    maxHeight: 300,
                    height: 300,
                    width: 270,
                    maxWidth: 270
                },
            }}
        >
            <div className='w-full'>
                <div className='w-full h-56 h-56 mt-2 px-4 overflow-y-auto'>
                    {messages.length > 0 ? (
                        messages.map(message =>
                            <div className='flex border-b border-solid border-gray py-2'>
                                <div className='mx-2'>
                                    <Avatar
                                        sx={{
                                            width: 45,
                                            height: 45,
                                            backgroundColor: "#d1d5db",
                                        }}
                                        src={message.body.sender?.photo?.fileURL}
                                        alt={message.body.sender?.name}
                                    >
                                        <PersonIcon sx={{ width: 30, height: 30 }} />
                                    </Avatar>
                                </div>
                                <div>
                                    <p className='text-sm text-medium'>
                                        Nuevo mensaje de
                                    </p>
                                    {message?.body &&
                                        <p className='text-sm text-light'>
                                            {message.body?.sender ? message.body.sender?.name + ' ' + message.body.sender?.lastName : 'Cliente'}
                                        </p>
                                    }
                                    {message?.sender?.name &&
                                        <p className='text-sm text-light'>
                                            {message.body?.sender ? message.body.sender?.name + ' ' + message.body.sender?.lastName : 'Cliente'}
                                        </p>
                                    }
                                    <p className='text-sm text-medium text-zinc'>
                                        <Moment format="D [de] MMMM" locale="es">
                                            {message?.createdAt}
                                        </Moment>
                                    </p>
                                    <Link to={session?.userType === 'coach' ? `/messages/${message.body?.type}/${message.body?.roomId}` : '/messages'}>
                                        <button class="text-sm text-regular text-white bg-green hover:bg-hover px-3 py-1 my-1 rounded-lg">
                                            Ver mensaje
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        )

                    ) : (
                        <div className='text-base text-medium text-zinc text-center my-4 w-full'>
                            Sin Mensajes
                        </div>
                    )}
                </div>
                <Divider
                    sx={{
                        bgcolor: "#fff"
                    }}
                />
                <div className='bg-white text-center'>
                    <Link to="/messages">
                        <p className='text-base text-medium text-blue text-center pt-3'>
                            Ver todos los mensajes
                        </p>
                    </Link>
                </div>

            </div>
        </Menu>
    );
}

export default MessagesPopup;
